import { schemes } from "@zeal/common";
import { z } from "zod";

export const postGenerateOrderPaymentLinkSchema = z.object({
  companyID: schemes.uuid(),
  orderID: schemes.uuid(),
  customerAccountID: schemes.uuid(),
  send_to_admin: z.boolean().optional(),
});

export type TPostGenerateOrderPaymentLinkRequest = z.infer<
  typeof postGenerateOrderPaymentLinkSchema
>;
